module.exports = __webpack_public_path__ + "media/images/number_29-ce58d7f20cec3a9015a17ee3efd675a5.png";